import { ITemplateFormData } from '../models';

export function isNameValid(data: Partial<ITemplateFormData>) {
	return data?.name && data?.name.length > 1;
}
